import api from "./api.js";
let baseURL = process.env.VUE_APP_Url_baseData;
// 获取不同角色列表

export function getStaffList(params) {
  return api.post(`${baseURL}/api/StaffInfo/list`, params);
}
